const getOldFlow = () => {
  return {
    old: true,
    new: false,
  }
}

const getNewFlow = () => {
  return {
    old: false,
    new: true,
  }
}
export default ({ store }, inject) => {
  const getFlow = () => {
    const isLoggedIn = store.getters['user/isLoggedIn']
    if (!isLoggedIn) return getOldFlow()
    const userId = store.getters['user/userId']
    return userId % 2 !== 0 ? getOldFlow() : getNewFlow()
  }
  inject('ab', getFlow)
}
